// extracted by mini-css-extract-plugin
export default {"loginWrapper":"login-styles_loginWrapper__WYKkz","loginHeader":"login-styles_loginHeader__xItyB","loginForm":"login-styles_loginForm__axkqS"};